import React from "react"
import HeroContent from "./hero-content"
import ScrollAnimation from "react-animate-on-scroll"
import HeroImgDesktop from "./engaging-menu-img-desktop"
import HeroImgMobile from "./engaging-menu-img-mobile"
import EngagingMenuPageStyle from "./engaging-menu-page.module.scss"

const Hero = () => (
    <div className={EngagingMenuPageStyle.heroDiv}>
        <ScrollAnimation className="fadeIn" animateOnce={true} duration={2}>
            <HeroImgDesktop />
            <HeroImgMobile />
        </ScrollAnimation>
        <HeroContent />
    </div>
)

export default Hero